import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime:0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getJobPosition = createAsyncThunk(
  "admin/jobPosition",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/master/job-position", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getJobPositionById = createAsyncThunk(
  "admin/jobPosition/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/master/job-position/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortJobPosition = createAsyncThunk(
  "admin/jobPosition/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/master/job-position/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postJobPosition = createAsyncThunk(
  "admin/jobPosition/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/master/job-position", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteJobPosition = createAsyncThunk(
  "admin/jobPosition/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/master/job-position/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateJobPosition = createAsyncThunk(
  "admin/jobPosition/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/master/job-position/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const jobPositionSlice = createSlice({
  name: "Job Position Store",
  initialState: initialState,
  reducers: {
    addJobPosition(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortJobPosition(state, action) {
      state.data.docs = action.payload;
    },
    deleteJobPosition(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editJobPosition(state, action) {
      state.data.docs = state.data.docs.map((item) =>
        item._id === action.payload._id ? action.payload : item
      ); 
      state.data.docs.shift();
    },
  },
  extraReducers: {
    [getJobPosition.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getJobPosition.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getJobPosition.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getJobPositionById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getJobPositionById.fulfilled]: (state, action) => {
      state.data.docs.unshift(action.payload.data);
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getJobPositionById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortJobPosition.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortJobPosition.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortJobPosition.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postJobPosition.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postJobPosition.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postJobPosition.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteJobPosition.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteJobPosition.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteJobPosition.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateJobPosition.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateJobPosition.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateJobPosition.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const jobPositionActions = jobPositionSlice.actions;

export default jobPositionSlice.reducer;
